 

interface styles {
    [key: string]: string | number; // Index signature with string key and string value
}


 

const chatWindowStyle: styles = {
    position: 'relative', top: '0px', left: '0px' , width : 'auto' , zIndex : '0'
}


 


export {
    chatWindowStyle
  
}